import { UserDetails } from '@DStypes/User';
import { PricingPlans } from '@constants/pricing';
import { createSlice } from '@reduxjs/toolkit';

const initialState: UserDetails = {
  user: {
    email: '',
    id: '',
    is_beta: false,
    is_demo_user: false,
    user_uuid: ''
  },
  first_name: '',
  last_name: '',
  company_name: '',
  role: '',
  industry: '',
  initial_plan_choice: '',
  full_name: '',
  plan: PricingPlans.NO_ACTIVE_SUBSCRIPTION,
  is_trial: false,
  project_count: 0,
  plan_start_date: '',
  plan_end_date: '',
  expired_plan_is_trial: false,
  expired_plan: PricingPlans.NO_ACTIVE_SUBSCRIPTION,
  has_used_trial: false,
  data_updates_remaining: 0,
  squirby_limit_remaining: 0,
  insights_limit_remaining: 0,
  api_updates_remaining: 0,
  api_uploads_remaining: 0
};

export const userDetails = createSlice({
  name: 'userDetails',
  initialState,
  reducers: {
    setUserDetails: (state, { payload }) => ({ ...state, ...payload })
  }
});

export const { setUserDetails } = userDetails.actions;

export default userDetails.reducer;
